export const webTemp = {
  backgroundColor: "#fff",
  marginTop: "20px",
  borderRadius: "0.5rem",
  border: "1px solid rgb(112, 112, 112,0.24)",
  padding: "20px",
};

export const borderBottomTitle = {
  borderBottom: "1px solid rgb(112, 112, 112,0.24)",
};
export const Color = {
  white: "#FFFFFF",
  primary: "#E42A3F",
  secandery: "#281A50",
  text: "#777777",
  textdark: "#444444",
  tabBar: "#EDEDED",
  light: "#F5F5F5",
  silver: "#F0F0F0",
  gold: "#FFCC11",
  lightYellow: "#FDFFC6",
  greenLight: "#39AF62",
  lightgray: "#EEEEEE",
  primarygradient: "#4F0A08",
  secanderygradient: "#5634B5",
  gray: "#e1e1e1",
  graygradient: "#F3F3F3",
  themeColor: "#fff",
  black: "#000",
  auth: {
    text: "#A7A7A7",
    title: "#777777",
  },
  textSecondry: "#81858b",
  club: {
    blue: "#00CBDA",
    yellow: "#FFD83A",
  },
  btnBlack: "#141C1F",
  textGray: "#81868a",
  grayLight: "#F5F7F6",
  greenSlider: "rgb(2, 138, 26)",
  yellow: "#F9C10A",
  blueSlider: "#1ba0d8",
};
